import Helper from './Helper';
import mapTextsDe from '../Maps/mapTextsDe.js';
import mapTextsEn from '../Maps/mapTextsEn.js';
import mapTextsFr from '../Maps/mapTextsFr.js';
import customWorld from '@highcharts/map-collection/custom/world-palestine.geo.json';

class Map {
  constructor() {
    this.body = document.querySelector('body');
    this.map = document.querySelector('#worldmap');
    this.tooltip = document.querySelector('#worldmap-tooltip');
    this.toolbox = document.querySelector('#worldmap-tools');
    this.backbutton = document.querySelector('.ns-map__back-btn');
    this.legend = document.querySelector('#worldmap-legend');
    this.inputfield = document.querySelector('#worldmap-input');
    this.plus = document.querySelector('.ns-map__zoom-plus');
    this.minus = document.querySelector('.ns-map__zoom-minus');
    this.zoompercent = document.querySelector('.ns-map__zoom-percent');
    this.dropdownbtn = document.querySelector('.ns-map__dropdown');
    this.search = document.querySelector('.ns-map__search');
    this.data = [];
    this.dataFromClick = [];
    this.worldMap = customWorld;
    this.currentMap = customWorld;
    this.baseMapPath = "https://code.highcharts.com/mapdata/";
    this.currentMapContainer = null;
    this.zoomfactor = 100;
    this.isDetailMap = false;

    this.makeTooltipTemplate = this.makeTooltipTemplate.bind(this);

    if (NSContext?.language) {
      switch (NSContext?.language) {
        case "de":
          this.texts = mapTextsDe;
          break;
        case "en":
          this.texts = mapTextsEn;
          break;
        case "fr":
          this.texts = mapTextsFr;
          break;

        default:
          this.texts = mapTextsDe;
          break;
      }
    }

    if (this.map) {
      //data from inline script
      this.dataForMapSrc = dataForMapSrc;
      Highcharts.mytexts = this.texts;
      this.mapLanguageTexts();
      this.bindEvents();
    }
  }

  mapLanguageTexts() {
    this.dataForMapSrc = this.dataForMapSrc.map(item => {
      const country = this.texts.country[item.key];
      if (NSContext && NSContext.language == 'de' || NSContext.language == 'fr') {
        item.chf = item.chf.replace('.', ',');
        item.newCommitment = item.newCommitment.replace('.', ',');
      }

      return {
        ...item,
        title: country.title,
        region: country.region,
      }
    });
  }

  bindEvents() {
    //build select
    let ul = document.createElement("ul");
    ul.classList.add('ns-map__list');
    let span = document.createElement('span');
    //add span for error-text
    span.classList.add('ns-map__search-no-match');
    span.innerHTML = '';
    this.dataForMapSrc = this.dataForMapSrc.sort((a, b) => {
      if (a.title < b.title) return -1;
      if (a.title > b.title) return 1;
    });

    // set all data attributres and create li element?
    this.dataForMapSrc.forEach((item, i) => {
      let url = "countries/" + item.key + "/" + item.key + "-all.js";
      let li = document.createElement("li");
      li.classList.add("ns-map__list-item");
      li.classList.add("ns-map__list-item-" + item.key);
      li.setAttribute("data-value", item.value);
      li.setAttribute("data-url", url);
      li.setAttribute("data-chf", item.chf);
      li.setAttribute("data-key", item.key);
      li.setAttribute("data-newcommitment", item.newCommitment);
      li.setAttribute("tabindex", 0);
      li.innerHTML = item.title;
      ul.append(li);
      this.search.append(ul);
      this.search.appendChild(span);
      item.element = li;

      //on click li-element
      li.addEventListener("click", (e) => {
        this.chooseCountryFromList(e.currentTarget, item);
      });

      //on enter, when li-element is in focus
      li.addEventListener('keyup', (e) => {
        if (event.keyCode === 13) {
          this.chooseCountryFromList(e.currentTarget, item);
        }
      });
    });

    this.inputfield.addEventListener("keyup", (e) => {
      let listItem = document.querySelectorAll('.ns-map__list-item');
      this.updateOrder(this.inputfield.value);

      let noMatch = 0;
      listItem.forEach((item, i) => {
        Helper.addClass(item, 'not-visible');
        if (item.innerHTML.toLowerCase().includes(this.inputfield.value.toLowerCase()) && e.keyCode !== 13 && e.keyCode !== 9) {
          Helper.removeClass(item, 'not-visible');
        } else if (!item.innerHTML.toLowerCase().includes(this.inputfield.value.toLowerCase()) && e.keyCode !== 13 && e.keyCode !== 9) {
          noMatch++
        }

        let theSpan = document.querySelector('.ns-map__search-no-match');
        if (noMatch === listItem.length && theSpan) {
          theSpan.innerHTML = this.texts.searchnomatch;
          Helper.addClass(this.inputfield, 'no-match');
          Helper.removeClass(this.dropdownbtn, 'ns-map__dropdown--is-open');
        } else {
          theSpan.innerHTML = '';
          Helper.removeClass(this.inputfield, 'no-match');
          Helper.addClass(this.dropdownbtn, 'ns-map__dropdown--is-open');
        }
      });

      //add class to open dropdown when user is typing
      if (!Helper.hasClass(ul, 'is-open')) {
        Helper.addClass(ul, 'is-open');
      }

      //if user pushes back button and we have no content in input field, close list
      if (e.keyCode === 8 && this.inputfield.value.length === 0) {
        let list = document.querySelector('.ns-map__list');
        Helper.removeClass(this.backbutton, 'is-visible');
        this.currentMap = this.worldMap;
        this.isDetailMap = false;
        this.tooltip.innerHTML = '';
        this.mapChange(this.currentMap);
        Helper.removeClass(list, 'is-open');
        Helper.removeClass(this.dropdownbtn, 'ns-map__dropdown--is-open');
      }

      //if user pushes escape close list
      if (e.keyCode === 27) {
        let list = document.querySelector('.ns-map__list');
        this.inputfield.value = '';
        if (Helper.hasClass(list, 'is-open')) {
          Helper.removeClass(list, 'is-open');
          Helper.removeClass(this.dropdownbtn, 'ns-map__dropdown--is-open');
        }
      }
    });

    this.mapChange(this.currentMap);
    this.zoompercent.innerHTML = this.zoomfactor + '%';
    this.buildBackButton(this.backbutton);

    this.backbutton.addEventListener("click", () => {
      Helper.removeClass(this.backbutton, 'is-visible');
      this.currentMap = this.worldMap;
      this.isDetailMap = false;
      this.tooltip.innerHTML = '';
      this.mapChange(this.currentMap);
      this.inputfield.value = '';
    });

    this.dropdownbtn.addEventListener('click', () => {
      const list = document.querySelector('.ns-map__list');
      if (Helper.hasClass(list, 'is-open')) {
        Helper.removeClass(list, 'is-open');
        Helper.removeClass(this.dropdownbtn, 'ns-map__dropdown--is-open');
      } else {
        Helper.addClass(list, 'is-open');
        Helper.addClass(this.dropdownbtn, 'ns-map__dropdown--is-open');
      }
    });
  }

  updateOrder(searchString) {
    this.dataForMapSrc = this.dataForMapSrc.sort((a, b) => {
      if (a.title < b.title) return -1;
      if (a.title > b.title) return 1;
    })

    if (searchString && searchString.trim().length != 0) {
      this.dataForMapSrc = this.dataForMapSrc.sort((a, b) => {
        const titleFragmentA = a.title.split(' ');
        const titleFragmentB = b.title.split(' ');

        const startsWith = {
          a: titleFragmentA.some(f => f.toLowerCase().startsWith(searchString.toLowerCase())),
          b: titleFragmentB.some(f => f.toLowerCase().startsWith(searchString.toLowerCase()))
        }

        const includesString = {
          a: a.title.includes(searchString),
          b: b.title.includes(searchString)
        }

        if(a.title.toLowerCase().startsWith(searchString.toLowerCase()) && b.title.toLowerCase().startsWith(searchString.toLowerCase())) {
          return a.title < b.title? -2 : 2;
        }else if(a.title.toLowerCase().startsWith(searchString.toLowerCase())) {
          return -2;
        } else if (b.title.toLowerCase().startsWith(searchString.toLowerCase())){
          return 2;
        }

        // if(startsWith.a && startsWith.b) {
        //   console.log(a.title, startsWith)
        //   return a.title < b.title? -2 : 2;
        // }else if(startsWith.a) {
        //   console.log("a starts with", searchString)
        //   return -2;
        // } else if (startsWith.b){
        //   return 2;
        // }

        if (a.title < b.title) return -1;
        if (a.title > b.title) return 1;
      })
    }

    this.dataForMapSrc = this.dataForMapSrc.map((item, i) => {
      item.element.style.order = i;
      item.order = i;
      return item;
    });
  }

  //fetch data for detailed map and call this.mapChange function after click
  fetchData(url, currentMapObj) {
    fetch(url)
      .then(response => response.json())
      .then((data) => {
        this.currentMap = data
        this.mapChange(data, currentMapObj);
      });
  }

  getUrlOnClick(item) {
    let url = "countries/" + item.key + "/" + item.key + "-all.geo.json";
    //if the key is hongkong, we load map of China, because hongkong doesn't exist as map
    if (item.key === 'hk') {
      url = "countries/cn/cn-all.geo.json";
    }
    return url;
  }

  chooseCountryFromList(listItem, item) {
    let list = document.querySelector('.ns-map__list');
    let currentMapUrl = this.baseMapPath + this.getUrlOnClick(item);
    this.dataFromClick.value = listItem.getAttribute('data-value');
    this.dataFromClick.chf = listItem.getAttribute('data-chf');
    this.dataFromClick.key = listItem.getAttribute('data-key');
    this.dataFromClick.newCommitment = listItem.getAttribute('data-newcommitment');
    this.dataFromClick.title = listItem.innerHTML;
    this.isDetailMap = true;
    //fetch the data for detailed map
    this.fetchData(currentMapUrl, this.dataFromClick);

    //set the zoomfactor to 100%
    this.zoomfactor = 100;
    this.zoompercent.innerHTML = this.zoomfactor + '%';

    //add tooltip to detailed map
    this.addTooltipTemplate(this.dataFromClick);

    //add class to make back-button visible
    Helper.addClass(this.backbutton, 'is-visible');

    //remove class of dropdown-list to close it when land is chosen
    if (Helper.hasClass(list, 'is-open')) {
      Helper.removeClass(list, 'is-open');
      Helper.removeClass(this.dropdownbtn, 'ns-map__dropdown--is-open');
    }

    //show chosen country in search-field
    this.inputfield.value = this.dataFromClick.title;
  }

  makeTooltipTemplate(element) {
    let div = document.createElement("div");
    div.classList.add("ns-tooltip");
    //if Risikokategorie 8 is, make HI
    let elementValue = element.value;
    if (elementValue === '8') {
      elementValue = 'HI'
    }

    // land
    let landwrapper = document.createElement("div");
    landwrapper.classList.add('ns-tooltip__text-wrapper');
    let land = document.createElement("p");
    land.classList.add("ns-tooltip__small-text");
    land.innerHTML = this.texts.land;
    let landName = document.createElement("p");
    landName.classList.add("ns-tooltip__text");
    landName.innerHTML = element.title;
    landwrapper.appendChild(land);
    landwrapper.appendChild(landName);

    // risiko
    let categoriewrapper = document.createElement("div");
    categoriewrapper.classList.add('ns-tooltip__text-wrapper');
    let categorie = document.createElement("p");
    categorie.classList.add("ns-tooltip__small-text");
    categorie.innerHTML = this.texts.risikokategorie;
    let categorieName = document.createElement("p");
    categorieName.classList.add("ns-tooltip__text");
    categorieName.innerHTML = this.texts.legendenKuerzel + ' ' + elementValue;
    categoriewrapper.appendChild(categorie);
    categoriewrapper.appendChild(categorieName);

    // engagement
    let engagementwrapper = document.createElement("div");
    engagementwrapper.classList.add('ns-tooltip__text-wrapper');
    let engagement = document.createElement("p");
    engagement.classList.add("ns-tooltip__small-text");
    engagement.innerHTML = this.texts.engagement;
    let engagementName = document.createElement("p");
    engagementName.classList.add("ns-tooltip__text");
    engagementName.innerHTML = element.chf;
    engagementwrapper.appendChild(engagement);
    engagementwrapper.appendChild(engagementName);

    // newCommitment
    let newCommitmentWrapper = document.createElement("div");
    newCommitmentWrapper.classList.add('ns-tooltip__text-wrapper');
    let newCommitment = document.createElement("p");
    newCommitment.classList.add("ns-tooltip__small-text");
    newCommitment.innerHTML = this.texts.newCommitment;
    let newCommitmentName = document.createElement("p");
    newCommitmentName.classList.add("ns-tooltip__text");
    newCommitmentName.innerHTML = element.newCommitment;
    newCommitmentWrapper.appendChild(newCommitment);
    newCommitmentWrapper.appendChild(newCommitmentName);

    div.appendChild(landwrapper);
    div.appendChild(categoriewrapper);
    div.appendChild(engagementwrapper);
    div.appendChild(newCommitmentWrapper);
    return div;
  }

  addTooltipTemplate(element) {
    let tooltip = this.makeTooltipTemplate(element);
    this.tooltip.innerHTML = '';
    this.tooltip.appendChild(tooltip);
  }

  buildBackButton(button) {
    let icon = document.createElement("span");
    let text = document.createElement("span");
    text.classList.add('ns-map__close-btn-text');
    text.innerHTML = this.texts.backbutton;
    button.appendChild(icon);
    button.appendChild(text);
  }

  mapChange(theCurrentMap, theData = null) {
    this.legend.innerHTML = '';
    if (!theData) {
      this.dataForMapSrc.map((item) => {
        this.data.push({
          key: item.key,
          title: item.title,
          region: item.region,
          value: item.value,
          chf: item.chf,
          newCommitment: item.newCommitment,
        });
      });
    } else {
      theCurrentMap.features.map((item) => {
        this.data.push({
          key: item.properties['hc-key'],
          value: theData.value,
          chf: theData.chf,
          title: theData.title,
          newCommitment: theData.newCommitment,
        });
      });
    }
    // Instantiate chart
    let chart = Highcharts.mapChart(this.map, {
      chart: {
        animation: false,
        styledMode: true,
        height: '50%',
        events: {
          load: (e) => {
            var chart = e.target;
            chart.series.forEach((serie, i) => {
              var childText = document.createElement("span");
              childText.classList.add("ns-map__legend-text");
              childText.innerHTML = this.texts.kartenLegende;
              serie.colorAxis.dataClasses.forEach((data, i) => {
                if (data.name != null) {
                  var parent = document.createElement("div");
                  var child = document.createElement("span");
                  var childColors = document.createElement("span");
                  child.classList.add("ns-map__legend-item-child");
                  childColors.classList.add("ns-map__legend-item-child-color");
                  parent.classList.add("ns-map__legend-item");
                  parent.classList.add("ns-map__legend-item-" + data.colorIndex);
                  parent.setAttribute("data-index", i);
                  child.innerHTML = data.name;
                  parent.prepend(child);
                  parent.prepend(childColors);
                  document.querySelector('#worldmap-legend').prepend(childText);
                  document.querySelector('#worldmap-legend').append(parent);
                }
              });
            });
          }
        }
      },

      title: {
        text: null
      },

      mapNavigation: {
        enableMouseWheelZoom: false,
        enableDoubleClickZoomTo: true,
        enabled: false
      },


      colorAxis: {
        dataClasses: [{
          from: 8,
          to: 8,
          colorIndex: 0,
          name: this.texts.legendenKuerzel + ' HI'
        }, {
          from: 0,
          to: 0,
          colorIndex: 3,
          name: this.texts.legendenKuerzel + ' 0'
        }, {
          from: 1,
          to: 1,
          colorIndex: 7,
          name: this.texts.legendenKuerzel + ' 1'
        }, {
          from: 2,
          to: 2,
          colorIndex: 6,
          name: this.texts.legendenKuerzel + ' 2'
        }, {
          from: 3,
          to: 3,
          colorIndex: 1,
          name: this.texts.legendenKuerzel + ' 3'
        }, {
          from: 4,
          to: 4,
          colorIndex: 2,
          name: this.texts.legendenKuerzel + ' 4'
        }, {
          from: 5,
          to: 5,
          colorIndex: 5,
          name: this.texts.legendenKuerzel + ' 5'
        }, {
          from: 6,
          to: 6,
          colorIndex: 8,
          name: this.texts.legendenKuerzel + ' 6'
        }, {
          from: 7,
          to: 7,
          colorIndex: 4,
          name: this.texts.legendenKuerzel + ' 7'
        }, {
          from: 'nd',
          to: 'nd',
          colorIndex: 9,
          name: ''
        }],
      },

      legend: {
        enabled: false
      },

      annotations: {
        visible: false,
      },

      tooltip: {
        borderRadius: 0,
        distance: 0,
        outside: true,
        enabled: this.isDetailMap ? false : true,
        shadow: false,
        useHTML: true,
        animation: false,
        formatter: function () {
          return '<div class="ns-tooltip">' +
            '<div class="ns-tooltip__text-wrapper">' +
            '<p class="ns-tooltip__small-text">' + Highcharts.mytexts.land + '</p>' +
            '<p class="ns-tooltip__text">' + this.point.title + '</p>' +
            '</div>' +
            '<div class="ns-tooltip__text-wrapper">' +
            '<p class="ns-tooltip__small-text">' + Highcharts.mytexts.risikokategorie + '</p>' +
            '<p class="ns-tooltip__text">' + Highcharts.mytexts.legendenKuerzel + (this.point.value === '8' ? 'HI' : this.point.value) + '</p>' +
            '</div>' +
            '<div class="ns-tooltip__text-wrapper">' +
            '<p class="ns-tooltip__small-text">' + Highcharts.mytexts.engagement + '</p>' +
            '<p class="ns-tooltip__text">' + (this.point.chf === '' ? Highcharts.mytexts.zero : this.point.chf) + '</p>' +
            '</div>' +
            '<div class="ns-tooltip__text-wrapper">' +
            '<p class="ns-tooltip__small-text">' + Highcharts.mytexts.newCommitment + '</p>' +
            '<p class="ns-tooltip__text">' + (this.point.newCommitment === '' ? Highcharts.mytexts.zero : this.point.newCommitment) + '</p>' +
            '</div>' +
            '</div>'
        },
        padding: 15,
        style: {
          whiteSpace: 'wrap'
        }
      },

      series: [{
        data: this.data,
        mapData: theCurrentMap,
        joinBy: ['hc-key', 'key'],
        dataLabels: {
          enabled: false
        },
        point: {
          events: {
            // On click, look for a detailed map
            click: (e) => {
              this.dataFromClick = {
                value: e.point.value,
                key: e.point.key,
                title: e.point.title,
                chf: e.point.chf,
                newCommitment: e.point.newCommitment,
              };

              let currentMapUrl = this.baseMapPath + this.getUrlOnClick(this.dataFromClick);
              this.isDetailMap = true;

              //fetch the data for detailed map
              this.fetchData(currentMapUrl, this.dataFromClick);
              //set the zoomfactor to 100%
              this.zoomfactor = 100;
              this.zoompercent.innerHTML = this.zoomfactor + '%';
              //add fixed Toolbox to map
              this.addTooltipTemplate(this.dataFromClick);
              //add class to make back-button visible
              Helper.addClass(this.backbutton, 'is-visible');
              //show chosen country in search-field
              this.inputfield.value = this.dataFromClick.title;
            }
          }
        }
      }]
    });

    this.plus.addEventListener("click", (e) => {
      chart.mapZoom(0.5);
      this.zoomfactor = this.zoomfactor / 0.5;
      this.zoompercent.innerHTML = this.zoomfactor + '%';
    });

    this.minus.addEventListener("click", (e) => {
      chart.mapZoom(2);
      this.zoomfactor = (this.zoomfactor <= 100) ? 100 : this.zoomfactor / 2;
      this.zoompercent.innerHTML = this.zoomfactor + '%';
    });
  }
}

export default Map;
